import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=21d126aa&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=21d126aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d126aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d126aa')) {
      api.createRecord('21d126aa', component.options)
    } else {
      api.reload('21d126aa', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=21d126aa&scoped=true&", function () {
      api.rerender('21d126aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27l2zJyDc321a/JS/comp/DateRangeExt.vue"
export default component.exports